import './MultipleImage.css';
import React from 'react';
import { injectImageResolution } from '../../../utils';
import LazyPicture from '../../atoms/LazyPicture';
var MultipleImage = function MultipleImage(_ref) {
  var imgSrc1 = _ref.imgSrc1,
    alt1 = _ref.alt1,
    imgSrc2 = _ref.imgSrc2,
    alt2 = _ref.alt2,
    rtl = _ref.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: rtl ? rtlStyles : ltrStyles
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    className: "section-detail-content__first__picture"
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: "".concat(injectImageResolution(imgSrc1, 340, 440))
  }), /*#__PURE__*/React.createElement("img", {
    src: "".concat(injectImageResolution(imgSrc1, 158, 200)),
    alt: alt1
  })), /*#__PURE__*/React.createElement(LazyPicture, {
    className: "section-detail-content__second__picture"
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: "".concat(injectImageResolution(imgSrc2, 340, 440))
  }), /*#__PURE__*/React.createElement("img", {
    src: "".concat(injectImageResolution(imgSrc2, 158, 200)),
    alt: alt2
  })));
};
var rtlStyles = "r5nylsi";
var ltrStyles = "l18hddu0";
export default MultipleImage;